exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".caption_colored[data-v-5ca649d5]{color:var(--caption-text-color)}\n", ""]);

